import { Component, Inject, OnInit, Output, EventEmitter } from '@angular/core';
import { saveAs } from 'file-saver';
import { DATA_TOKEN } from 'src/app/shared/Theme/services/zen-cdk.service';
import { Workbook } from 'exceljs';

export interface JsonExportData {
  data: any[],
  name: string,
  title?: string,
  grouping?: boolean,
  includeTitle?: boolean,
  groupBy?: string,
  categoryBy?: string,
  modify?: (row) => {}
}

@Component({
  selector: 'app-json-to-excel',
  template: '',
})
export class JsonToExcelComponent implements OnInit {
  grouping: boolean = false;
  includeTitle: boolean = false;
  groupBy: string = "Group";
  categoryBy: string = "Category";
  fileName = '';
  title = ''
  arrayRecords = [];
  @Output() close = new EventEmitter();
  @Output() results = new EventEmitter();

  constructor(@Inject(DATA_TOKEN) private data: JsonExportData) {
  }
  ngOnInit(): void {
    this.fileName = this.data.name;
    this.arrayRecords = this.data.data;
    this.includeTitle = this.data.includeTitle;

    if (this.data?.title)
      this.title = this.data.title
    if (this.data?.groupBy)
      this.groupBy = this.data.groupBy;
    if (this.data?.categoryBy)
      this.categoryBy = this.data.categoryBy;
    if (this.data?.grouping)
      this.grouping = this.data.grouping;

    this.export(this.arrayRecords, this.fileName);
  }

  export(records, name) { 
    const workbook = new Workbook();
    const sheet = workbook.addWorksheet('Main');
    let headerRowIndex = 1;


    // preparing data

    if (this.grouping) {
      sheet.columns = [this.groupBy, ...[...new Set(records.map((item) => item[this.categoryBy] || 'N/A'))]]
        .map((x) => {
          return { header: x, key: x, width: 15 }
        }
        );
      const groupedData = records.reduce((acc, item) => {
        const groupName = item[this.groupBy] || '';
        const categoryName = item[this.categoryBy] || 'N/A';
        if (groupName.trim()) {
          if (!acc[groupName]) acc[groupName] = { [this.groupBy]: groupName };
          acc[groupName][categoryName] = item.Value ?? 0;
        }
        return acc;
      }, {});
      records = Object.values(groupedData);

    }
    else {
      sheet.columns = Object.keys(records[0]).map((key, i) => {
        const result = key.replace(/([A-Z])/g, " $1");
        return {
          header: result.charAt(0).toUpperCase() + result.slice(1),
          key: key,
          width: 15,
        }
      })
    }



    // plotting title
    if (this.includeTitle) {
      const nameRow = sheet.insertRow(1, [this.title || name]);

      nameRow.eachCell({ includeEmpty: true }, (cell) => {
        cell.font = {
          bold: true,
          size: 16
        };
      });

      sheet.insertRow(2, []);
      headerRowIndex = 3;
    }

    const headerRow = sheet.getRow(headerRowIndex);

    sheet.columns.forEach((x, i) => {
      headerRow.getCell(x.key).font = {
        bold: true,
        size: 12,
        color: { argb: 'FFFFFF' },
      }

      headerRow.getCell(x.key).fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '0082C6' },
      }
    })



    // plotting rows
    records.forEach((row, i) => {
      sheet.addRow(row);
      if (this.data?.modify) {
        this.data.modify(sheet.getRow(headerRowIndex + i + 1));
      }
    });




    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const fileName = name || this.title || ''
      saveAs(blob, `${fileName}.xlsx`);
      this.close.emit(true);
    });
  }

}
